import { render, staticRenderFns } from "./ProvidersForm.vue?vue&type=template&id=895e6b4c"
import script from "./ProvidersForm.vue?vue&type=script&lang=js"
export * from "./ProvidersForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports